import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const PaymentRequest = ()=>{
    const [paymentRequest, setPaymentRequest] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`paymentRequest?page=${page}`);
            setPaymentRequest(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`paymentRequest/${id}`);
            setPaymentRequest(paymentRequest.filter((paymentRequest) => paymentRequest.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Payment Requests'}>
            
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Time in </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">Party A </th>
                                    <th className="px-4 py-3">Party B </th>
                                    <th className="px-4 py-3">Account Reference </th>
                                    <th className="px-4 py-3">Response Code </th>
                                    <th className="px-4 py-3">Response Description </th>
                                    <th className="px-4 py-3">Error Message </th>
                                    <th className="px-4 py-3">Error Code </th>
                                    <th className="px-4 py-3">Requestid </th>
                                    
                                    
                                   
                                  
                                    
                                     {/* <th className="px-4 py-3">Action</th> */}
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {paymentRequest && paymentRequest.length > 0 ? (
                                         paymentRequest.map((paymentRequest)=>(
                                             <tr key={paymentRequest.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{paymentRequest.id}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.time_in}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.Amount}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.PartyA}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.PartyB}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.AccountReference}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.ResponseCode}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.ResponseDescription}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.ErrorMessage}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.ErrorCode}</td>
                                                 <td className="px-4 py-3 text-sm">{paymentRequest.request_id}</td>
                                                 
                                                 
                                                 
                                               
                                                 
                                                 {/* <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/paymentRequest/${paymentRequest.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(paymentRequest.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td> */}
                                             </tr>
                                         ))
                                ) : (
                                            <tr>
                                                <td colSpan="12" className="text-center py-5 text-gray-500">No data to display </td>
                                            </tr>
                                         )}
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default PaymentRequest;